// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2-tsm","topBottomGutter":"Layout_topBottomGutter__3ZB9h"};